import { useQuery } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { authApi } from '@/api/auth.api';
import { tokenStore } from '@/auth/token';
import { useAuthStore } from '@/auth/useAuthStore';

export const authKeys = {
  me: () => ['auth', 'me'] as const,
};

export const useMe = () => {
  const setMeInfo = useAuthStore((s) => s.setMeInfo);

  return useQuery({
    queryKey: authKeys.me(),
    queryFn: async () => {
      const data = await authApi.getMe();
      setMeInfo(data);
      Sentry.setUser({ id: data.id, email: data.email });
      return data;
    },
    enabled: !!tokenStore.get(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
